/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'plus': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M34 23.499v2.961c0 .275-.246.54-.522.54H26v7.459c0 .275-.24.541-.516.541h-2.961c-.275 0-.523-.266-.523-.541V27h-7.5c-.275 0-.5-.265-.5-.54v-2.961a.5.5 0 0 1 .5-.499H22v-7.5c0-.275.248-.5.523-.5h2.961c.276 0 .516.225.516.5V23h7.478c.276 0 .522.224.522.499z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/plus.js